import React from 'react';
import moment from 'moment';
import NoDataMsg from 'library/noData';
import { colorCategory, getDollarFormat } from 'utils/helpers';
import { Button } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import GenericTable from 'screens/components/advanced/GenericTable';

const Body = ({ productSales, endDate, beginDate, handleShowCategorySummary, showCategorySummary }) => {
    let categorySummaryColumns = [
        { key: "Category", label: "Category" },
    ]
    let { province: productProvince } = productSales || [];
    productProvince = productProvince ? [...new Set(productProvince.split(", "))] : []; // Split the result into array and remove duplicate values
    console.log(productProvince);

    // Change to test with array not string
    if (productProvince.includes("BC") || productProvince.includes("British Columbia")) {
        categorySummaryColumns.push({ key: "PST", label: "PST" },
            { key: "GST", label: "GST" },
            { key: "PST_VAPE", label: "PST_VAPE" })
    } else if (productProvince.includes("AB") || productProvince.includes("Alberta")) {
        categorySummaryColumns.push({ key: "GST", label: "GST" })
    } else if (productProvince.includes("ON") || productProvince.includes("Ontario")) {
        categorySummaryColumns.push({ key: "HST", label: "HST" })
    }

    categorySummaryColumns.push(
        { key: "DiscountAmount", label: "Discount Amount" },
        { key: "DepositAmount", label: "Deposit Amount" },
        { key: "GrossSales", label: "Gross Sales" })

    return (
        <React.Fragment>
            {
                productSales.list && productSales.list.length <= 0 ?
                    //If there's NO DATA to display
                    <NoDataMsg />
                    :
                    //If there's DATA
                    <div>
                        <div>
                            <div className="row m-0 list_header text-center">
                                {beginDate ?
                                    <p><i>From</i> <b>{moment(beginDate).format('MMMM Do, YYYY')}</b> <i> to </i>
                                        {endDate ? <b>{moment(endDate).format('MMMM Do, YYYY')}</b> : moment().format('MMMM Do, YYYY')}</p>
                                    : moment().format('MMMM D, YYYY')}
                            </div>
                        </div>
                        {
                            productSales.summary &&
                            <div className="row m-0 mb-2">
                                <div className="col-lg-12 title_summary">
                                    <h3 className="m-0">SUMMARY</h3>
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-6 col-xs-6 text-center border-right">
                                    {productProvince.includes("BC") || productProvince.includes("British Columbia") ?
                                        <div className="row">
                                            <h4 className="m-0 font-weight-semibold">Taxes</h4>
                                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 text-center">
                                                <h5 className="m-0 font-weight-semibold">PST</h5>
                                                <h4 className="m-0 purple-text size_1-4vmax ">{`$${(productSales.summary.totalPST).toFixed(2)}`}</h4>
                                            </div>
                                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 text-center">
                                                <h5 className="m-0 font-weight-semibold">GST</h5>
                                                <h4 className="m-0 purple-text size_1-4vmax ">{`$${(productSales.summary.totalGST).toFixed(2)}`}</h4>
                                            </div>
                                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 text-center">
                                                <h5 className="m-0 font-weight-semibold">PST_VAPE</h5>
                                                <h4 className="m-0 purple-text size_1-4vmax ">{`$${(productSales.summary.totalPST_Vape).toFixed(2)}`}</h4>
                                            </div>
                                        </div>
                                        : productProvince.includes("AB") || productProvince.includes("Alberta") ?
                                            <div>
                                                <h4 className="m-0 font-weight-semibold">GST</h4>
                                                <h3 className="m-0 purple-text size_1-3vmax ">{`$${(productSales.summary.totalGST).toFixed(2)}`}</h3>
                                            </div>
                                            : productProvince.includes("ON") || productProvince.includes("Ontario") ?
                                                <div>
                                                    <h4 className="m-0 font-weight-semibold">HST</h4>
                                                    <h3 className="m-0 purple-text size_1-3vmax ">{`$${(productSales.summary.totalHST).toFixed(2)}`}</h3>
                                                    <br />
                                                </div> : <div></div>
                                    }
                                </div>
                                <div className="col-lg-2 col-md-2 col-sm-6 col-xs-6 text-center border-right">
                                    <h4 className="m-0 font-weight-semibold">Discount Amount</h4>
                                    <h3 className="m-0 purple-text size_1-3vmax ">{`$${(productSales.summary.totalDiscount).toFixed(2)}`}</h3><br />
                                </div>
                                <div className="col-lg-3 col-md-3 col-sm-6 col-xs-6 text-center border-right">
                                    <h4 className="m-0 font-weight-semibold">Deposit Amount</h4>
                                    <h3 className="m-0 purple-text size_1-3vmax ">{`$${(productSales.summary.totalDepositAmount).toFixed(2)}`}</h3><br />
                                </div>
                                <div className="col-lg-3 col-md-3 col-sm-6 col-xs-6 text-center border-right">
                                    <h4 className="m-0 font-weight-semibold">Gross Sales</h4>
                                    <h3 className="m-0 purple-text size_1-3vmax ">{`$${(productSales.summary.totalGrossSales).toFixed(2)}`}</h3><br />
                                </div>

                            </div>
                        }
                        {productSales.categoryAll &&
                            <div className="row m-0 mb-2">
                                <Button
                                    label=""
                                    startIcon={<VisibilityIcon />}
                                    fullWidth={true}
                                    sx={{ color: "white", backgroundColor: "#9683E5" }}
                                    variant={"contained"}
                                    onClick={() => handleShowCategorySummary()}
                                >
                                    Show Summary By Category
                                </Button>
                                {showCategorySummary &&
                                    <div className="discount-report-table">
                                        <GenericTable
                                            className="table_center tableHeaderwhiteColorFont"
                                            stripedRows={true}
                                            columns={categorySummaryColumns}
                                            rows={productSales.summaryByCategory.map((item) => {
                                                return {
                                                    Category: item.categoryName,
                                                    PST: getDollarFormat(item.totalPST),
                                                    GST: getDollarFormat(item.totalGST),
                                                    PST_VAPE: getDollarFormat(item.totalPST_Vape),
                                                    HST: getDollarFormat(item.totalHST),
                                                    DiscountAmount: getDollarFormat(item.totalDiscount),
                                                    DepositAmount: getDollarFormat(item.totalDepositAmount),
                                                    GrossSales: getDollarFormat(item.totalGrossSales),
                                                    BranchName:item.branchName
                                                }
                                            })
                                            }
                                        />
                                    </div>
                                }
                            </div>
                        }
                        {
                            productSales.list &&
                            <div className="col-lg-12 title_summary">
                                <h3 className="m-0">DETAILS</h3>
                            </div>
                        }
                        <div className="pl-2 pr-2">
                            {
                                productSales.list && productSales.list.map((item, index) => {
                                    //Category Style
                                    const categoryStyle = {
                                        background: {
                                            backgroundColor: colorCategory(item.cannabisName)
                                        },
                                        textColor: {
                                            color: colorCategory(item.cannabisName)
                                        }
                                    }

                                    return (
                                        <div className="row m-0 border_bottom_grey pt-2 pb-2 price_info col-4-padding" key={index}>
                                            <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12 m-0 p-0">
                                                <div className="row m-0 p-0">
                                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 m-0 pl-2 pt-1" style={categoryStyle.textColor}>
                                                        <h4 className="m-0 font-weight-semibold">{item.productName}</h4>
                                                        <span>SKU: {item.sku}</span><br />
                                                        <span>UPC: {item.upc}</span><br />
                                                        <span>Branch Name: {item.branchName}</span><br />
                                                        <span className="capitalize" >{item.cannabisName == null ? "Uncategorized, " + item.category : item.cannabisName + ", " + item.category}</span><br />
                                                        {item.lotNumber && <span className="capitalize" >{`Lot Number: ${item.lotNumber}`}</span>}<br />
                                                        {item.mostRecentPO && <span>Recent PO#: {item.mostRecentPO}</span>}<br />
                                                        <span className="capitalize" >Status: {item.status}</span><br />
                                                        {item.refundReason && <span className="capitalize" >{`Refund Reason: ${item.refundReason}`}</span>}<br />
                                                        {item.refundReason && item.notes && <span className="capitalize" >{`Notes: ${item.notes}`}</span>}
                                                    </div>
                                                </div>
                                            </div> {/* END OF COLUMN */}

                                            <div className="row col-lg-2 col-md-2 col-sm-2 col-xs-12 m-0 p-0 text-right">
                                                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-2 m-0 p-0 text-center">
                                                    <label>Date</label>
                                                    <p>
                                                        <i>{moment(item.createdDate).format('MMM D, YYYY')}</i>
                                                    </p>
                                                </div>
                                                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-3 m-0 p-0 text-center">
                                                    <label>Qty</label>
                                                    <h5>{item.productType == 2 ? item.quantity + ' unit(s)' : item.quantity + ' g'}</h5>
                                                </div>
                                                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-4 m-0 p-0 text-center">
                                                    <label>Weight (gram or ml)</label>
                                                    <h5>{item.weightPerUnit}</h5>
                                                </div>
                                            </div>{/* END OF COLUMN */}
                                            <div className="row col-lg-4 col-md-4 col-sm-3 col-xs-12 m-0 p-0 text-right">
                                                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-4 m-0 p-0 text-center">
                                                    <label>Total Base Price</label>
                                                    <h5>${(item.totalBasePrice || 0).toFixed(2)}</h5>
                                                </div>
                                                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-4 m-0 p-0 text-center">
                                                    <label>Total Selling Price</label>
                                                    <h5>${(item.subtotalincludingdiscount || 0).toFixed(2)}</h5>
                                                </div>
                                                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-4 m-0 p-0 text-center">
                                                    <label>Profit Margin</label>
                                                    <h5>{((item.transactionProfitMargin || 0) * 100).toFixed(2)}%</h5>
                                                </div>
                                            </div>
                                            <div className="row col-lg-1 col-md-1 col-sm-3 col-xs-12 m-0 p-0 text-right">
                                                {
                                                    productProvince.includes("BC") || productProvince.includes("British Columbia") ?
                                                        <div>
                                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-4 m-0 p-0 text-center">
                                                                <label>PST</label>
                                                                <h5>${(item.pst || 0).toFixed(2)}</h5>
                                                            </div>
                                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-4 m-0 p-0 text-center">
                                                                <label>GST</label>
                                                                <h5>${(item.gst || 0).toFixed(2)}</h5>
                                                            </div>

                                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-4 m-0 p-0 text-center">
                                                                <label>PST Vape</label>
                                                                <h5>${(item.pstVape || 0).toFixed(2)}</h5>
                                                            </div>
                                                        </div>
                                                        :
                                                        productProvince.includes("AB") || productProvince.includes("AB") ||productProvince.includes("Alberta") ?
                                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-4 m-0 p-0 text-center">
                                                                <label>GST</label>
                                                                <h5>${(item.gst || 0).toFixed(2)}</h5>
                                                            </div>
                                                            :
                                                            productProvince.includes("ON") || productProvince.includes("Ontario") ?
                                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-4 m-0 p-0 text-center">
                                                                    <label>HST</label>
                                                                    <h5>${(item.hst || 0).toFixed(2)}</h5>
                                                                </div>
                                                                : <div></div>
                                                }
                                            </div>
                                            <div className="row col-lg-3 col-md-3 col-sm-2 col-xs-12 m-0 p-0 ">
                                                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-4 m-0 p-0 text-center">
                                                    <label>Discount Amount</label>
                                                    <h4 className="danger">{item.discountAmount == 0 ? "$0" : "-$" + `${(item.discountAmount || 0).toFixed(2)}`}</h4>
                                                </div>
                                                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-4 m-0 p-0 text-center">
                                                    <label>Deposit Amount</label>
                                                    <h4 className="danger">{item.depositAmount == 0 ? "$0" : "-$" + `${(item.depositAmount || 0).toFixed(2)}`}</h4>
                                                </div>
                                                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-4 m-0 p-0 text-center">
                                                    <label>Gross Sales</label>
                                                    <h4 className="money">${(item.grossSales || 0).toFixed(2)}</h4>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </div>
            }
        </React.Fragment>
    );
};

export default Body;